import React from 'react';
import LocalizedLink from 'helpers/LocalizeLink';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import footer_logo from 'assets/img/footer-logo.svg';
import CookiesToolsWidget from 'components/widgets/CookiesToolsWidget';
import { useLocation } from 'react-router-dom';
import { getLocaleLink } from 'helpers/util';


function Footer() {
    const { t } = useTranslation();
    const location = useLocation();
    const { pathname } = location;
    const splitLocation = pathname.split("/");
    const socialItems = useSelector((store) => store.socials) || [];
    const menuItems = useSelector((store) => store.menus) || [];

    const isActive = (path) => {
        return splitLocation.length === 3 && splitLocation[2] === path ? ' isActive active' : '';
    };

    const FooterMenuItems = (props) => {

        return (
            <ul className='footer-menu'>
                {
                    menuItems === undefined || menuItems === null || menuItems.length === 0 ? null :
                        menuItems.map((item, key) =>
                            item.type === 'footer' ?
                                item.menu_items.map((menu_item, key_key) =>
                                    <div key={'mapkey-' + key + '-' + key_key}>
                                        <li className={'footer-menu-item mb-3' + isActive(`${menu_item.slug}`)} key={key + '_' + key_key} onClick={window.scrollTo(0, 0)}>
                                            <LocalizedLink to={getLocaleLink(menu_item.slug)} dti={"ftr-nav-item-" + key_key} className='footer-menu-link text-white'>{menu_item.name}</LocalizedLink>
                                        </li>
                                        {
                                            menu_item.subitems !== undefined && menu_item.subitems !== null && menu_item.subitems.length > 0 ?
                                                menu_item.subitems.map((subitem, subitem_index) =>

                                                    subitem.menu_id === menu_item.menu_id ?
                                                        <li className={'sub footer-menu-item mb-3' + isActive(`${subitem.slug}`)} key={key + '_' + key_key + '_' + subitem_index} onClick={window.scrollTo(0, 0)}>
                                                            <LocalizedLink to={getLocaleLink(subitem.slug)} dti={"ftr-nav-sub-item-" + subitem_index} className='footer-menu-link text-white'>{subitem.name}</LocalizedLink>
                                                        </li> : null

                                                ) : null
                                        }
                                    </div>
                                ) : ''
                        )
                }
            </ul>);

    };

    return (
        <>
            <footer className='footer py-28 py-sm-16'>
                <div className="container-xl text-sm-center">
                    <div className="row mb-4 mb-md-5">
                        <div className="footer-logo col-md-3 col-lg-4 mb-4 mb-md-0">
                            <img alt={'OppoTrade'} src={footer_logo} />
                        </div>
                        <div className="col-md-9 col-lg-8">
                            <nav>
                                <FooterMenuItems />
                            </nav>
                        </div>
                    </div>
                    <div className="footer-copy row align-items-center">
                        <div className="col-md-3 col-lg-4 d-flex align-items-end justify-content-center justify-content-md-start mb-3 mb-md-0">
                            <p className="text-white text-small">{t('footer.copyright')}</p>
                        </div>
                        <div className="col-md-7 col-lg-6 d-flex flex-column flex-md-row align-items-center justify-content-center justify-content-md-start">
                            <span className='text-white text-small mr-0 mr-md-4 mb-3 mb-md-0'>{t('footer.social_networks')}</span>
                            <div className='text-null d-flex align-items-center mb-3 mb-md-0'>
                                {
                                    socialItems.map((socialitem, socialitem_index) => {

                                        if (
                                            !socialitem?.light_img?.alt &&
                                            !socialitem?.light_img?.source)
                                            return null;

                                        if (
                                            !socialitem?.light_img?.source)
                                            return (
                                                <p
                                                    data-test-id={"ftr-social-alt-" + socialitem_index}
                                                    key={'socials' + socialitem_index + socialitem?.id}
                                                    onClick={(e) => {
                                                        e.preventDefault();
                                                        if (socialitem?.url) {
                                                            window.open(socialitem.url, '_blank');
                                                        }
                                                    }}>{socialitem?.light_img?.alt}</p>);

                                        return (
                                            <img key={'socials' + socialitem_index + socialitem?.id}
                                                data-test-id={"social-url-ftr-" + socialitem_index}
                                                title={socialitem?.light_img?.title}
                                                alt={socialitem?.light_img?.alt}
                                                src={socialitem?.light_img?.source}
                                                className='social-img mr-3'
                                                onClick={(e) => {
                                                    e.preventDefault();
                                                    if (socialitem?.url) {
                                                        window.open(socialitem.url, '_blank');
                                                    }
                                                }} />);
                                    })
                                }
                            </div>
                        </div>
                        <div className="col-md-2 col-lg-2 d-flex align-items-center justify-content-center justify-content-md-start mb-3 mb-md-0">
                            <a rel="noopener noreferrer" href={`${getLocaleLink('/release_notes')}`} target="_blank" className='text-decoration-none text-white text-small'>
                                {t("Release notes")}
                            </a>
                        </div>
                    </div>
                </div>
            </footer>
            <CookiesToolsWidget />
        </>);

}

export default Footer;